import { Dimension, type DimensionFunnelMap, dimensionLabelsMap } from "../../models/dimension-funnel";

export type FunnelSlicePath = [Dimension, string];

export const makeDimensionLabels = (
    breakdownDimension: Dimension,
    dimensionFunnelMap: DimensionFunnelMap,
): [FunnelSlicePath, string][] => {
    let labelEntries = Object.entries(dimensionLabelsMap[breakdownDimension]);

    // pick top 10 countries based on Lens Views
    if (breakdownDimension === Dimension.COUNTRY) {
        labelEntries = labelEntries
            .sort(([key1, value1], [key2, value2]) => {
                const funnel1 = dimensionFunnelMap["COUNTRY"]?.[key1]?.LENS_VIEWS;
                const funnel2 = dimensionFunnelMap["COUNTRY"]?.[key2]?.LENS_VIEWS;

                if (funnel1?.value !== funnel2?.value) {
                    return (funnel2?.value ?? 0) - (funnel1?.value ?? 0);
                }

                return value1.localeCompare(value2);
            })
            .slice(0, 10);
    }

    return labelEntries.reduce((acc: [FunnelSlicePath, string][], [key, value]) => {
        return [...acc, [[breakdownDimension, key], value]];
    }, []);
};
